// Port of api/fuel/app/classes/insights/worth/status.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'

var wishlistPriority = {
	must: 1,
	love: 2,
	like: 3,
	maybe: 4,
	dont: 5
}

var statusConstants = {
	own: 1,
	prevowned: 2,
	fortrade: 3,
	want: 4,
	wanttoplay: 5,
	wanttobuy: 6,
	wishlist: 7,
	preordered: 8,
	hasparts: 9,
	wantparts: 10
}

export default Segment.extend({
	name: 'status',
	insight: false,
	detail: false,
	run: function(type, owner, userIndex) {
		if (!owner.get_count_collection()) return {}

		var rawStatus = Util.queryFast(
			'SELECT collection_own AS own, collection_prevowned AS prevowned, collection_fortrade AS fortrade,' +
			' collection_want AS want, collection_wanttoplay AS wanttoplay, collection_wanttobuy AS wanttobuy,' +
			' collection_wishlist AS wishlist, collection_preordered AS preordered, collection_hasparts AS hasparts,' +
			' collection_wantparts AS wantparts, collection_wishlist_priority AS wp, collection_value AS cv,' +
			' game_worth_value AS gv FROM collection c, game g' +
			' WHERE c.user_id IN(' + Util.in(userIndex) + ') AND g.game_id = c.game_id'
		)

		var wishlist = {}
		var status = {}
		var wishlistKeys = Object.keys(wishlistPriority)
		var statusKeys = Object.keys(statusConstants)

		for (var i = 0; i < wishlistKeys.length; i++) {
			var priorityId = wishlistPriority[wishlistKeys[i]]
			wishlist[priorityId] = {
				count: 0,
				value: 0,
				id: priorityId
			}
		}

		for (var j = 0; j < statusKeys.length; j++) {
			status[statusKeys[j]] = {
				count: 0,
				value: 0,
				id: statusKeys[j]
			}
		}

		for (var r = 0; r < rawStatus.length; r++) {
			var row = rawStatus[r]
			var value = parseFloat(row.cv) || 0

			if (parseInt(row.wishlist, 10)) {
				var priorityId = parseInt(row.wp, 10) || 0
				if (priorityId && wishlist[priorityId]) {
					wishlist[priorityId].count++
					wishlist[priorityId].value += value
				}
			}

			for (var s = 0; s < statusKeys.length; s++) {
				var key = statusKeys[s]
				if (parseInt(row[key], 10)) {
					status[key].count++
					status[key].value += value
				}
			}
		}

		return {
			status: {
				all: status,
				wishlist: wishlist
			}
		}
	}
})
